import PressReleaseCard from 'components/Tiles/PressReleaseCard';
import { ArticleSearchResponse } from 'model/Article';

export const PressReleaseCardAdapter: React.FC<{ articleCard: ArticleSearchResponse }> = ({
  articleCard,
  ...rest
}) => <PressReleaseCard fields={articleCard} {...rest} />;
